import { defineComponent as _defineComponent } from 'vue'
import Vue, { computed, onMounted, ref } from 'vue';
import { performAction } from '@/services/vue-utils';
import i18n from '@/plugins/i18n';
import store from '@/store/store';
import { useVuetify } from '@/components/helpers/vue2-helpers';
import router from '@/router';


export default /*#__PURE__*/_defineComponent({
  __name: 'DeleteAccountDialog',
  setup(__props) {

const vuetify = useVuetify();

const deleteFieldRef = ref<HTMLElement>();

const deleteConfirmText = ref('');

const reason = ref(undefined as number | undefined);
const otherReason = ref('');

const deleteEnabled = computed(() => deleteConfirmText.value.toUpperCase() === 'DELETE' && reason.value !== undefined);

onMounted(() => {
  setTimeout(() => {
    deleteFieldRef.value?.focus();
  }, 300);
});

const deleteAccount = async () => {
  const reasonIndex = reason.value ?? 4;
  const reasonText = reasonIndex === 4
    ? otherReason.value || i18n.tc('label.delete_reason_other')
    : i18n.tc(`label.delete_reason_${reasonIndex + 1}`);

  const ok = await performAction(
    i18n.tc('message.success_delete_account'),
    i18n.tc('error.deleting_account'),
    async () => store.dispatch('deleteAccount', { reasonText }),
  );

  if (!ok) return;

  vuetify.theme.dark = false;
  router.push('/login');
};


return { __sfc: true,vuetify, deleteFieldRef, deleteConfirmText, reason, otherReason, deleteEnabled, deleteAccount }
}

})